import { defineMessages } from 'react-intl'

/* eslint-disable max-len */

export default defineMessages({
  title: 'Take the initiative',
  subtitle: 'Please note',
  info: 'Applications sent by post cannot be taken into account during the application process. For this reason, application portfolios will also not be returned.',
  btn: 'Get in touch now'
})
